import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const Youtube: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 25.65 25.65">
            {props.title && <title>{props.title}</title>}
            <defs>
                <style>
                    {`
              .cls-1 {
                fill: #27a5cb;
                stroke-width: 0px;
              }
            `}
                </style>
            </defs>
            <path className="cls-1" d="M20.52,0H5.13C2.3,0,0,2.3,0,5.13v15.39c0,2.83,2.3,5.13,5.13,5.13h15.39c2.83,0,5.13-2.3,5.13-5.13V5.13c0-2.83-2.3-5.13-5.13-5.13ZM6.27,13.13c-.2-.56-.32-1.14-.55-1.68,0-.01-.01-.02-.02-.03,0,.01.01.02.02.03-.06-.15-.14-.3-.22-.45-.65-1.1-1.58-.04-2.56-.19-.26-.04-.39-.23-.52-.44-.07-.12-.15-.24-.25-.34v-.11c1.42-1.13,2.67-2.51,4.32-3.47.52-.3,1.39-.63,2.11-.42.56.16,1.03.83,1.31,1.47,0,0,0,0,0,0,.05.12.09.23.13.35.27.86.42,1.9.56,2.74.22,1.32.18,3.21.93,4.44,0,0,0,0,0,0,.1.16.21.31.34.45,1.21,1.3,2.14-.5,2.63-1.42.43-.8.81-1.63.88-2.39.04-.43.02-.77-.06-1.04q-.11-.14,0,0c-.21-.77-.86-.95-1.88-.91-.13,0-.27.01-.41.02.93-2.88,3.66-4.09,4.47-4.21.99-.15,2.44-.12,3.12.74.14.17.23.36.3.56.17.51.15,1.09.05,1.66-.22,1.14-1.65,5.13-4.25,8.66-1.14,1.49-2.47,2.95-4.17,3.96-.63.37-1.87.84-2.7.49-.58-.24-1.02-.76-1.38-1.41,0,0,0,0,0,0-.64-1.16-.99-2.76-1.29-3.96-.28-1.11-.54-2.16-.88-3.12ZM5.65,11.35s0,0,0,.01c0,0,0,0,0-.01Z" />
        </svg>
    );
};

export default React.memo(Youtube);
